<template>
  <div id="app" ref="app">
     <router-view ></router-view>
  </div>
</template>
<script>
import util from "@/util/util";
import question from "@/api/question";
// import home from "@/api/home";
import request from "@/util/request";
export default {
  name: "App",
  data() {
    return{
      cuserviceShow:true
    }
  },
  created() {
    const unConnet = ["loading", "login"];
    if (util.getCookie("token") && unConnet.indexOf(this.$route.name) == -1) {
      this.connectwebsockt();
      this.handRefresh();
      this.cuserviceShow = true
    }else{
      this.cuserviceShow = false
    }
  },
  mounted() {},
  destroyed() {},
  methods: {
    handRefresh(){
      const treenum = {
        print_type:1,
        start_time:util.getlimiTime(2) + ' 00:00:00',
        end_time:util.getlimiTime(0)+' 23:59:59',
      }
      request.post(this,{
        action:'kdyserver.account.homeBus',
        data:{
          'parameters':request.getBusparameters([
            {action:'kdyserver.order.logistics.orderstatic',data:{}},
            {action:'kdyserver.account.banners',data:{type:1,account_id: util.getCookie("account_id")}},
            {action:'kdyserver.order.printOrderStatics',data:treenum},
            {action:'kdyserver.team.model.select',data:{account_id: util.getCookie("account_id")}},
            {action:'kdyserver.account.hasbind',data:{account_id: util.getCookie("account_id")}},
            {action:'kdyserver.message.getIsRead',data:{account_id: util.getCookie("account_id")}},
          ])
        }
      }).then(res=>{
        if(res.success){
           const datas = res.body.data; 
           this.$store.commit("SET_PRINT_NUM", datas[0].data.yes_print_num);
           this.$store.commit("SET_ORDER_NUM", datas[0].data.yes_print_num);
           this.$store.commit("SET_BANNER_LIST", datas[1].data);
           this.$store.commit("SET_WAIT_NUM", datas[2].data);
           util.setCookie("teamModel", datas[3].data);
           this.$store.commit('SET_TEAM_MODEL', datas[3].data)
           this.$store.commit("SET_BIND_KDY", datas[4].data);
           this.$store.commit("SET_MAIL_NUM", datas[5].code== 200 ? 0 : 1);
        }
      })
    },
    beforeunloadHandler(e) {
      e = e || window.event;
      console.log("兄弟们，我歇比了！");
      this.$WebSocketClass.close();
    },
    getBanner() {
      question.bannerList(this).then((res) => {
        if (res.success) {
          this.$store.commit("SET_BANNER_LIST", res.data);
        }
      });
    },
    connectwebsockt() {
      this.$WebSocketClass.envConnect();
    },
  },
};
</script>
<style lang="stylus">
*{
  margin 0;
  padding 0;
  list-style none;
  font-family '方正楷体'
}
a{
  text-decoration none
}
 html,body{height:100%}
 #app{height:100%}
 .import_red{
   color: #E6A23C
 }
 .ysb_lxkf{
  position: fixed;
  right: 0;
  background-color: yellow;
  z-index: 99;
  width: 20px;
  height: 100px;
}
</style>
